'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MenuArrowButton;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function MenuArrowButton(props) {
  var arrow = props.arrow,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave;
  var className = (0, _classnames2["default"])('rainbow-picklist_dropdown-arrow-button', 'rainbow-picklist_dropdown-arrow-' + arrow);
  return _react2["default"].createElement('div', {
    className: className,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  });
}

MenuArrowButton.propTypes = {
  arrow: _propTypes2["default"].oneOf(['up', 'down']).isRequired,
  onMouseEnter: _propTypes2["default"].func,
  onMouseLeave: _propTypes2["default"].func
};
MenuArrowButton.defaultProps = {
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {}
};